var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"point-name"},[_vm._v(_vm._s(_vm.when)+"の"+_vm._s(_vm.name))]),_c('p',{staticClass:"point-num"},[_c('span',{staticClass:"point-num-val"},[_vm._v(_vm._s(_vm.pointVal))]),_vm._v("pt ")])])}
var staticRenderFns = []

export { render, staticRenderFns }